import { useQuery } from '@tanstack/react-query';

import { useCurrentOrgId } from '@/features/org/hooks/use-current-org-id';
import { getAddons } from '@/features/subscriptions/api/get-addons';

export const ADDON_SUBSCRIPTIONS_QUERY_KEY = 'addon-subscriptions';

export function useAddonSubscriptions() {
  const orgId = useCurrentOrgId();

  return useQuery({
    queryKey: [ADDON_SUBSCRIPTIONS_QUERY_KEY, orgId],
    queryFn: () => getAddons(orgId ?? 0),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
